import TextField from '@mui/material/TextField'
import { ChangeEvent, useState } from 'react'
import { ILocation } from '../../../../../../../app/entities/Location'
import PrimaryCheckbox from '../../../../../global/components/checkbox/Checkbox'
import styles from './styles.module.css'

export interface ILocationFormProps {
  setLocationFormInfo: Function
  locationFormInfo: Partial<ILocation>
}

export function LocationForm(props: ILocationFormProps) {
  const {
    name,
    addressStreet,
    addressCity,
    stateAbbr,
    zipCode,
    workDayFrom,
    workDayTo,
    productionMode,
    standbyQueueActive,
    routingAlgorithm,
    lunchDuration,
    travelTimeMax,
    costCenter,
  } = props.locationFormInfo

  const [userRole] = useState(localStorage.getItem('Role'))

  function updateLocationForm(e: ChangeEvent<HTMLInputElement>) {
    props.setLocationFormInfo({
      ...props.locationFormInfo,
      [e.target.name]: e.target.value,
    })
  }

  function updateProductionMode(e: ChangeEvent<HTMLInputElement>) {
    props.setLocationFormInfo({
      ...props.locationFormInfo,
      productionMode: e.target.checked,
    })
  }

  function updateStandbyQueueActive(e: ChangeEvent<HTMLInputElement>) {
    props.setLocationFormInfo({
      ...props.locationFormInfo,
      standbyQueueActive: e.target.checked,
    })
  }

  return (
    <div className={styles.locationFormContainer}>
      <div className={styles.locationFormTitle}>Location</div>
      <TextField
        onChange={updateLocationForm}
        name='name'
        value={name || ''}
        className={styles.wideTextField}
        label='Name'
      />
      <TextField
        onChange={updateLocationForm}
        name='addressStreet'
        value={addressStreet || ''}
        className={styles.wideTextField}
        label='Street'
      />
      <TextField
        onChange={updateLocationForm}
        name='addressCity'
        value={addressCity || ''}
        className={styles.wideTextField}
        label='City'
      />
      <div className={styles.doubleFieldContainer}>
        <TextField
          onChange={updateLocationForm}
          name='stateAbbr'
          value={stateAbbr || ''}
          className={styles.narrowTextField}
          label='State Abbr'
        />
        <TextField
          onChange={updateLocationForm}
          name='zipCode'
          value={zipCode || ''}
          className={styles.narrowTextField}
          label='Zip'
        />
      </div>
      <div className={styles.workdayLabel}>Workday</div>
      <div className={styles.doubleFieldContainer}>
        <TextField
          onChange={updateLocationForm}
          name='workDayFrom'
          value={workDayFrom || ''}
          className={styles.narrowTextField}
          label='Workday From'
        />
        <TextField
          onChange={updateLocationForm}
          name='workDayTo'
          value={workDayTo || ''}
          className={styles.narrowTextField}
          label='Workday To'
        />
      </div>
      <div className={styles.doubleFieldContainer}>
        <TextField
          onChange={updateLocationForm}
          name='lunchDuration'
          value={lunchDuration || ''}
          className={styles.narrowTextField}
          label='Lunch Duration'
        />
      </div>
      <div className={styles.workdayLabel}>Routing</div>
      <div className={styles.doubleFieldContainer}>
        <TextField
          onChange={updateLocationForm}
          name='routingAlgorithm'
          value={routingAlgorithm || ''}
          className={styles.narrowTextField}
          label='Routing Algorithm'
          disabled={true}
        />
        <TextField
          onChange={updateLocationForm}
          name='travelTimeMax'
          value={travelTimeMax || ''}
          className={styles.narrowTextField}
          label='Max Drive Time'
          disabled={!['Admin', 'Super Admin'].includes(userRole || '')}
        />
      </div>
      <div className={styles.workdayLabel}>Cost Center</div>
      <TextField
        className={styles.narrowTextField}
        label='Cost Center'
        name='costCenter'
        onChange={updateLocationForm}
        type='number'
        value={costCenter}
      />
      <div className={styles.checkboxContainer}>
        <PrimaryCheckbox
          checked={productionMode as boolean}
          name='productionMode'
          onChange={updateProductionMode}
          label='Production Mode'
          className={styles.productionModeSmallText}
        />
        <PrimaryCheckbox
          checked={standbyQueueActive as boolean}
          name='standbyQueue'
          onChange={updateStandbyQueueActive}
          label='Standby Queue'
          className={styles.productionModeSmallText}
        />
      </div>
    </div>
  )
}
